import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AcquisitionLoot from './AquisitionResources/LootDrops.PNG'
import CaretakerLoot from './CaretakerResources/LootDrops.PNG'
import ExhibitionLoot from './ExhibitionResources/LootDrops.PNG'
import RhulkLoot from './RhulkResources/LootDrops.PNG'
import Symbols from './GeneralResources/symbols.jpg'
import AussieSymbols from './GeneralResources/bona_callouts.png'
import Challenge  from './ExhibitionResources/challenge.png'


const LootDrawer = ({image_number, aussieCallouts}) => {
  const [lootstate, setLootState] = React.useState(false)
  const loot_images = [AcquisitionLoot, CaretakerLoot, ExhibitionLoot, RhulkLoot]
  const toggleLootDrawer = () => {
    setLootState(!lootstate)
  }

  const [challengeState, setchallengeState] = React.useState(false)
  const toggleChallengeDrawer = () => {
    setchallengeState(!challengeState)
  }

  const renderChallenge = (encounter) => {
    switch(encounter){
      case 0:
        return <div style={{width: "500px", padding: "10px"}}>
                <h2> Rotating Challenge - Swift Destruction </h2>
                <p className="challengeBody"> Kill the champions within ~5 seconds of each other.  </p>
                <p className="challengeBody"> Either kill them as they spawn in pairs of two, or wait for one to spawn at each pillar and kill them simultaneously.  </p>

                <h2  style={{width: "500px", paddingTop: "100px"}}> Static Challenge - On My Go </h2>
                <p className="challengeBody"> "Only kill Abated Adherents when they've started attacking an Obelisk in Acquisition." </p>
                <p className="challengeBody"> Very buggy, stasis is reccomended to freeze them for as long as possible. </p>

              </div>;
      case 1:
        return <div style={{width: "500px", padding: "10px"}}>
                <h2> Rotating Challenge - Base Information </h2>
                <p className="challengeBody"> You may only carry (and enter) one buff at a time.  </p>
                <p className="challengeBody"> We used two runners for this but three works too, make sure stuns are on point.  </p>

                <h2  style={{width: "500px", paddingTop: "100px"}}> Static Challenge - Handle With Care </h2>
                <p className="challengeBody"> "Defeat the Caretaker while having every member of your fireteam stun it at least once per floor." </p>
                <p className="challengeBody"> Kinda buggy, I'd reccomend making a stun order. </p>

              </div>;
      case 2:
        return <div style={{width: "500px", padding: "10px"}}>
                <h2> Rotating Challenge - Defences Down </h2>
                <p className="challengeBody"> Each player can only kill 1 knight  </p>
                <p className="challengeBody"> Lots of relic swapping needed for this one, see the image below for set roles, or chaos works too.  </p>
                <img className="symbolImage" src={Challenge} />
                <p> credit to u/zellyn1 </p>

                <h2  style={{width: "500px", paddingTop: "50px"}}> Static Challenge - Glypth to Glypth </h2>
                <p className="challengeBody"> "Kill each set of Glyphkeepers in Exhibition within 5 seconds of each other." </p>
                <p className="challengeBody"> Have the fireteam split and go down both paths, count down to kill when both Glyphkeepers have spawned. </p>

              </div>;
      case 3:
        return <div style={{width: "500px", padding: "10px"}}>
                <h2> Rotating Challenge - Looping Catalyst </h2>
                <p className="challengeBody"> Don't lose leeching force during the banking phase.  </p>
                <p className="challengeBody"> Follow the Infographic on this page, the only change is that you cant use the second backup buff spawn.  </p>

                <h2  style={{width: "500px", paddingTop: "100px"}}> Static Challenge - Symmetrical Energy </h2>
                <p className="challengeBody"> "Any energy deposit in Dominion must be accompanied by another deposit within 5 seconds." </p>
                <p className="challengeBody"> Count down when depositing buffs, the strat used in the inforgaphic works with this challenge. </p>

              </div>;
      default:
        return "monkas this broke";
    }
  }

  return (
    <div >
      <Button onClick={toggleLootDrawer}>
        Show Loot Table
      </Button>
      <Button style={{float: "right"}} onClick={toggleChallengeDrawer}>
        Show Challenge
      </Button>
      <Drawer
              anchor="left"
              open={lootstate}
              onClose={toggleLootDrawer}

            >
            <img alt="loot table" src={loot_images[image_number]}/>
            <Typography> Infographic made by <a href="https://mobile.twitter.com/SquirrelyDan_/status/1501824876608434177"> @SquirrelyDan_</a> </Typography>
      </Drawer>

      <Drawer
              anchor="right"
              open={challengeState}
              onClose={toggleChallengeDrawer}
            >
            {renderChallenge(image_number)}
      </Drawer>
    </div>
  )
}

export default LootDrawer
